export default {
  potato: {
    1: 'ヘンリー・スポルディングが1837年にアイダホ州で最初にジャガイモを植えました。',
    2: '「フライドポテト」はトーマス・ジェファーソンがホワイトハウスのディナーで出した時にアメリカに持ち込まれました。',
    3: 'アメリカのポテト愛好家は、2017年にさまざまな形やサイズの400万トン以上のフライドポテトを消費しました。',
    4: 'ジャガイモは強力な媚薬です、とアイルランドの医師は言います。',
    5: '平均的なアメリカ人は年間140ポンドのジャガイモを食べます。ドイツ人は年間200ポンド以上食べます。',
    6: 'ギネス世界記録によると栽培された最大のジャガイモは18ポンド4オンスでした。1975年にイギリスで栽培されました。',
    7: 'ジャガイモは、小麦、トウモロコシ、米に次ぐ世界で4番目の主食です。',
    8: 'ジャガイモは125か国以上で栽培されています。',
    9: '毎年、世界を6周する4車線の高速道路をカバーするのに十分なジャガイモが世界中で栽培されています。',
    10: '中国は世界最大のジャガイモ生産国です。',
    11: 'ジャガイモは宇宙で最初に栽培された野菜です。',
    12: 'ジャガイモは完全にグルテンフリーです。',
    13: '最も基本的なインカの時間の長さの1つは、ジャガイモを調理するのにかかった時間でした。',
    14: 'ジャガイモが成長中に光にさらされると、緑色に変わり有毒になります。',
    15: '2,500ポンドのポテトチップスを製造するには10,000ポンドのジャガイモが必要です。',
    16: '今日、4000種類以上のジャガイモがあります。',
    17: 'ジャガイモは小さな科であるナス科に属しています。',
    18: 'アラスカのクロンダイク・ゴールドラッシュの間(1897-1898)、ジャガイモは同じ重さの金とほとんど同じ価値がありました。',
    19: 'サー・ウォルター・ローリーは1589年にアイルランドのコーク近くの40,000エーカーの土地にジャガイモを持ち込みました。',
    20: 'ジャガイモは年中毎月どこかで収穫されるので、1年中入手できます。',
    21: 'アフリカとアジア原産のヤムイモのサイズは、小さなジャガイモのサイズから130ポンドの記録的なサイズまでいろいろあります。',
    22: '8月19日と10月27日は国民のポテトデーです。',
    23: 'ジャガイモはウォッカ、ポッチーン、アクアビットなどのアルコール飲料の醸造にも使用されます。',
    24: 'ジャガイモは最も環境に優しい野菜の1つです。栽培が簡単で、他の多くの野菜のように成長するのに大量の肥料や化学添加剤を必要としません。',
    25: 'ジャガイモはペルー南部を起源とし、紀元前8000年から紀元前5000年の間に最初に栽培されました。',
    26: 'potatoという単語はスペイン語のpatataに由来しています。',
    27: 'ジャガイモは通常、マルハナバチなどの昆虫によって受粉されます。',
    28: 'ジャガイモは約80%の水分と20%の固形物からできています。'
  }
};
